import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {NotFoundDialogProps, NotFoundVariantEnum} from './types';

const {chatOnline} = translations['pt-br'].privateFlow.bookingFlow;
const {state, city, district} = translations['pt-br'].privateFlow.guideFlow.location.notFoundModal;
const {notice, changeCity} = translations['pt-br'].commons;

export function NotFoundDialog({
	variant,
	handleCallChatRoom,
	handleGuideNav,
	open,
	setOpen,
	isLoading,
	isDisabled,
}: NotFoundDialogProps) {
	const {isMobile} = useMediaQueries();

	const isDistrictVariant = variant === NotFoundVariantEnum.DISTRICT;

	const NOT_FOUND_CONTENT = (() => ({
		[NotFoundVariantEnum.CITY]: {
			title: city.title,
			description: city.description,
		},
		[NotFoundVariantEnum.UF]: {
			title: state.title,
			description: state.description,
		},
		[NotFoundVariantEnum.DISTRICT]: {
			title: district.title,
			description: district.description,
		},
	}))();

	return (
		<AlertModal
			slotProps={{
				paper: {
					style: {
						maxWidth: 420,
						margin: isMobile ? 16 : 'auto',
						flex: isMobile ? 1 : 'initial',
					},
				},
			}}
			footerContent={
				<AlertActions
					primaryAction={
						isDistrictVariant ? () => handleGuideNav() : () => handleCallChatRoom()
					}
					isDisabled={isDisabled}
					isLoading={isLoading}
					primaryText={isDistrictVariant ? changeCity : chatOnline}
					secondaryAction={isDistrictVariant ? () => handleCallChatRoom() : undefined}
					secondaryText={isDistrictVariant ? chatOnline : undefined}
					flexDirection="column-reverse"
				/>
			}
			description={NOT_FOUND_CONTENT[variant].description}
			headerTitle={notice}
			onClose={() => setOpen(false)}
			title={NOT_FOUND_CONTENT[variant].title}
			open={open}
			variant="primary"
		/>
	);
}
